import { FC, ReactElement, ReactNode } from "react";
import ProgressBar from "../common/ProgressBar";
import call from "../../images/call.svg";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";

const SubmitSkeleton: FC<SubmitSkeletonProps> = ({
  title,
  progress,
  hasNav = true,
  onPrev,
  onNext,
  nextBtnText = "Next",
  canProceed = true,
  children,
}) => {
  return (
    <div className="h-full flex relative w-full">
      <div className="bg-black h-full w-[42%] hidden lg:flex flex-col items-center justify-center">
        <p className="font-bold text-[40px] leading-[52px] text-white">
          “Speak bravely”
        </p>
      </div>

      <div className="bg-white h-full flex flex-col w-full lg:w-[58%]">
        <div className="py-2 bg-[#F4F4F4] justify-center items-center overflow-hidden">
          <div className="flex space-x-1 animate-marquee whitespace-nowrap">
            <img src={call} alt="phone" />
            <p className="font-[400] text-[14px] text-[#111110]">
              Incase of an emergency, please dial 911.
            </p>
          </div>
        </div>

        <div className="flex w-full justify-center overflow-y-auto flex-grow mt-[24px]">
          <div className="flex flex-col max-w-[571px] w-[calc(100%-48px)] xs:w-[70%]">
            <h2 className="font-extrabold text-[32px] leading-[38px] sm:text-[50px] xs:leading-[52px] text-gray-7">
              You are not alone
            </h2>

            <p className="text-gray-7 font-[400] text-[14px] leading-[18px] xs:text-base xs:leading-5 mt-4 sm:mt-8">
              We are working to understand what is happening and how it’s
              occuring. Your story is valuable. By collecting information, we
              can advocate for a better protection, educational resources, and
              policies that can put an end to this.
            </p>

            <div className="w-full flex justify-center my-6">
              <ProgressBar progress={progress * 100} />
            </div>

            {title && (
              <h5 className="font-bold xs:font-[700] text-[18px] leading-6 mb-4">
                {title}
              </h5>
            )}

            <div className="overflow-y-auto mb-6 flex-grow pl-1 pb-1 pr-4">
              {children}
            </div>

            {hasNav && (
              <div className="flex justify-between items-center w-full mb-5">
                <button
                  onClick={onPrev}
                  className={`bg-gray-7 text-white w-[42px] h-[42px] xs:w-[52px] xs:h-[52px] flex rounded-full justify-center items-center ${
                    onPrev ? "" : "invisible"
                  }`}
                >
                  <FaArrowLeft />
                </button>

                {onNext && (
                  <button
                    onClick={onNext}
                    className={`text-white font-[900] text-base leading-5 py-[11px] xs:py-4 px-4 rounded-[24px] flex items-center gap-2 ${
                      canProceed ? "bg-gray-7" : "bg-gray-4 cursor-not-allowed"
                    }`}
                  >
                    {nextBtnText}
                    {nextBtnText === "Next" && <FaArrowRight />}
                  </button>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SubmitSkeleton;

type SubmitSkeletonProps = {
  title?: string;
  progress: number;
  hasNav?: boolean;
  onPrev?: () => void;
  onNext?: () => void;
  nextBtnText?: string | ReactElement;
  canProceed?: boolean;
  children: ReactNode;
};
